import { useState } from 'react';
import {Helmet} from 'react-helmet';

import { Collapse, Button } from 'react-bootstrap';

const data = [
['Jak kupić bazę?', `Użyj generatora znajdującego się na samej górze strony głównej. Wybierz interesującą Cię branżę, lokalizację, datę rozpoczęcia działalności oraz liczbę firm, jaką planujesz zakupić, i zatwierdź, klikając przycisk WYGENERUJ. Następnie poczekaj, aż wyświetlą się wyniki, wybierz rodzaj danych i przejdź do procesu płatności. Zamawianie baz jest bardzo proste i odbywa się za pomocą generatora online.`],
['Ile kosztuje baza?', `Cena bazy firm jest zawsze ustalana indywidualnie na podstawie liczby wpisów oraz rodzaju danych, które wybierzesz podczas jej generowania. Koszt pojedynczego wpisu z adresem e-mail to 0,05 zł, z numerem telefonu – 0,07 zł, a za wpis zawierający podstawowe dane zapłacisz 0,01 zł. Jeśli wpis zawiera zarówno adres e-mail, jak i numer telefonu, jego cena wynosi 0,10 zł.`],
['Jak opłacić zamówienie?', `Po wybraniu parametrów i wygenerowaniu bazy danych firm ostatnim etapem składania zamówienia jest dokonanie płatności za pośrednictwem systemu HotPay. Gwarantuje on bezpieczeństwo, komfort i szybki transfer pieniędzy, dzięki czemu niemal natychmiast będziemy mogli zająć się realizacją Twojego zlecenia.`],
['Kiedy otrzymam bazę?', `Maksymalny czas oczekiwania na zakupioną bazę to 24 godziny, ale zazwyczaj dostarczamy plik z danymi już po kilku godzinach od chwili złożenia zamówienia.`],
['Jak pobrać bazę?', `Bazę dostarczymy Ci w załączniku na adres mailowy, który podałeś podczas finalizowania transakcji w systemie HotPay. Nie musisz rejestrować się na naszej stronie, aby pobrać zamówiony plik.`],
['Jakie dane zawiera baza?', `Po dokonaniu zakupu bazy przyślemy Ci plik XLSX zawierający dane firm takie jak: imię i nazwisko właściciela, nazwa firmy, NIP, REGON, data rozpoczęcia działalności, kody TERC, SIMC i ULIC, miejscowość, ulica, numer budynku, kod pocztowy, gmina, dzielnica, powiat, województwo, adres email, numer telefonu, adres strony internetowej, numer identyfikacyjny i ID wpisu.`],
['Skąd pobieracie dane?', `Najważniejsze źródła, które wykorzystujemy do budowy naszych baz, to CEIDG (Centralna Ewidencja i Informacja o Działalności Gospodarczej), REGON (Krajowy Rejestr Urzędowy Podmiotów Gospodarki Narodowej), KRS (Krajowy Rejestr Sądowy) oraz strony internetowe firm i popularne serwisy społecznościowe.`],
['Jak wykorzystać bazę?',`Zakupione u nas dane przydadzą się każdemu, kto planuje rozpocząć kampanię telemarketingową, e-mail marketingową, direct mailingową lub rozesłanie reklamy swojej marki drogą pocztową. Jeśli prowadzisz biznes i chcesz wypromować swój produkt, działania marketingowe na pewno Ci w tym pomogą, a żeby je przeprowadzić, potrzebne Ci będą dane kontaktowe jak największej liczby potencjalnych klientów, które możesz zdobyć dzięki naszemu serwisowi.`],
['Jak otrzymać zniżkę?', `Zdajemy sobie sprawę z tego, że duże bazy danych firm zawierające dziesiątki tysięcy wpisów to spory wydatek, dlatego w takich przypadkach zachęcamy Cię do kontaktu z nami jeszcze przed dokonaniem zakupu. Wystarczy, że sprecyzujesz, jaką bazą jesteś zainteresowany, a my postaramy się przygotować dla Ciebie specjalną ofertę z rabatem.`],
['Dlaczego warto kupić?',`Nasze bazy kontaktów różnią się od typowych baz, które można znaleźć na forach czy aukcjach. Dzięki odpowiedniemu filtrowaniu dostarczymy Ci listę potencjalnych klientów wyłącznie z Twojej branży i według wybranych przez Ciebie kryteriów. Dzięki temu można założyć, że wielu z nich będzie realnie zainteresowanych Twoją ofertą.`],
['Nie otrzymałem bazy, co robić?',`Pamiętaj, że bazę zawsze wysyłamy na adres e-mail podany podczas realizowania płatności w systemie HotPay. Upewnij się więc, że sprawdzasz odpowiednią skrzynkę e-mail. Następnie zajrzyj do folderu spam, ponieważ właśnie tam mogła trafić nasza wiadomość z załączoną bazą. Jeśli minęły 24 godziny od chwili złożenia zamówienia i wciąż nie otrzymałeś bazy, skontaktuj się z nami.`]

];

function FAQ() {

    const [open, setOpen] = useState(false);
    const [opened, setOpened] = useState(0);

    return (<>
        <Helmet>
        <title>FAQ - BazaMaili</title>
        <meta name="description" content="Poznaj odpowiedzi na najczęściej zadawane pytania. Dowiedz się, jak funkcjonuje serwis BazaMaili i sprawdź jego możliwości." />

        </Helmet>

{/* 
    <Button
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
      >
        click
      </Button>
      <Collapse in={open}>
        <div id="example-collapse-text">
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus
          terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer
          labore wes anderson cred nesciunt sapiente ea proident.
        </div>
      </Collapse> */}


            
            <div className="container">
                
                 <br/><br/>   
                    <h3><b><font color="#00539C">FAQ</font></b></h3>
                
                <div className="row">
                
        <div className="faqs">
            <div className="container">
                <div className="row">
                    
                    <div className="col-md-12">
                        <div id="accordion">


{data.map( (elem, id) => {
    return (
        <div className="card" key={id}>

            <div className="card-header">
                <button
                    type="button"
                    className="card-link"
                    aria-expanded={opened === id+1}
                    aria-controls={`faq-answer-${id}`}
                    onClick={() => {
                        if (opened === id+1) setOpened(0);
                        else setOpened(id+1);
                    }}
                >
                    <span>{id+1}</span> {elem[0]}
                </button>
            </div>

            {opened === id+1 && (
    <div
        className="card-body"
        id={`faq-answer-${id}`}
    >
        {elem[1]}
    </div>
)}

        </div>
    );
}) }
 
                        </div>
                       
                    </div>
                    
                </div>
            </div>
        </div>



                
                </div>
            </div>
        
    
    </>);
}
export default FAQ;